
import { Component, Prop, Watch } from 'vue-property-decorator'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import LineItem from '@/models/LineItem'
import ViewModel from '@/models/ViewModel'
import SelectOption from '@/models/interface/SelectOption'

@Component({
  components: {
    SelectPicker,
  },
})
export default class LineItemPicker extends ViewModel {
  @Prop({ default: true })
  public edit!: boolean

  @Prop({ default: false })
  public allow_empty!: boolean

  @Prop({ default: false })
  public disabled!: boolean

  @Prop({ default: false })
  public multiple!: boolean

  @Prop({ default: '' })
  public agency_id!: string

  @Prop({ default: '' })
  public station_id!: string

  @Prop({ default: '' })
  public advertiser_id!: string

  @Prop({ default: '' })
  public media_plan_id!: string

  @Prop({ default: false })
  public create_panel!: boolean

  @Prop({ default: 'LineItem' })
  public label!: string

  @Prop({ default: () => null })
  public value!: string | null

  @Prop({ default: false })
  public latest!: boolean

  @Prop({ default: false })
  public preLoad!: boolean

  public local_value: string[] | string | null = []

  public new_id: string = ''

  public show_sidebar: boolean = false

  public update: boolean = true

  public uuid: string = ''

  public busy: boolean = false

  public options: SelectOption[] = []

  public label_name: string = 'N/A'

  public ready: boolean = false

  public mounted() {
    this.uuid = this.randomUUID()

    if (this.latest && this.preLoad) {
      this.searchOptions()
    }
  }

  public created() {
    if (this.edit) {
      if (!this.value || (Array.isArray(this.value) && this.value.length == 0)) {
        this.local_value = this.value
        this.ready = true
      } else {
        this.busy = true
        LineItem.searchOptions({
          value: this.value,
        }).then(response => {
          this.options = response
          this.busy = false
          this.local_value = this.value
          this.ready = true
        })
      }
    } else {
      this.updateLabel()
    }
  }

  public open() {
    if (this.options.length == 0) this.searchOptions()
  }

  public updateLabel() {
    if (!this.value) {
      this.label_name = 'N/A'
    } else if (!Array.isArray(this.value)) {
      LineItem.module
        .searchOptions({
          value: this.value,
        })
        .then(response => {
          this.label_name = response[0].name
          this.ready = true
        })
    }
  }

  public searchOptions(search = '*') {
    this.busy = true
    if (!search) search = '*'

    LineItem.searchOptions({
      search: search.includes('*') ? search : `*${search}*`,
      agency_id: this.agency_id,
      station_id: this.station_id,
      advertiser_id: this.advertiser_id,
      media_plan_id: this.media_plan_id,
      latest: this.latest,
    }).then(response => {
      this.options = response
      if ((!this.value || !this.value.length) && response && this.latest) {
        // check if value is array
        if (Array.isArray(this.value)) {
          // @ts-ignore
          this.local_value = [response[response.length - 1].value]
        } else {
          // @ts-ignore
          this.local_value = response[response.length - 1].value
        }
        this.$emit('latest-loaded', true)
      }
      this.busy = false
      this.ready = true
    })
  }

  @Watch('local_value')
  public onChangeValue(val: any) {
    this.update = false
    if (val == null) {
      this.$emit('input', null)
    } else {
      this.$emit('input', this.local_value)
    }
  }

  @Watch('value')
  public onChangeProp(val: any) {
    if (this.update) {
      if (val == null) {
        this.local_value = null
      } else {
        this.local_value = this.value
      }
    }
    this.update = true
    this.updateLabel()
  }

  @Watch('company_id')
  public onChangeCompany() {
    this.searchOptions()
  }

  @Watch('station_id')
  public onChangeStation() {
    this.searchOptions()
  }
}
